import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requireAdminOrPermission,
} from '../route';
import { AppsPage } from './AppsPage';

/**
 * `/apps` — the organization's Apps, each opening at `/apps/$appId`. No
 * sidebar entry yet: Apps are Gently-authored and shared by link until
 * customers can build them (the sidebar requires a pure RBAC gate).
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/apps',
  component: AppsPage,
  loader: () => ({
    crumb: msg('Apps', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requireAdminOrPermission({
      context,
      action: Action.Read,
      subject: Subject.App,
    });
  },
});
